import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "[vds-main-nav-item]",
    templateUrl: "./main-nav-item.component.html",
    styleUrl: "./main-nav-item.component.css",
    encapsulation: ViewEncapsulation.None,
    host: {
        class: "vds-nav-item"
    },
    imports: []
})
export class MainNavItemComponent {}
